import { render } from "./leaderboard.vue?vue&type=template&id=2f6b3d27&scoped=true"
import script from "./leaderboard.vue?vue&type=script&lang=js"
export * from "./leaderboard.vue?vue&type=script&lang=js"

import "./leaderboard.vue?vue&type=style&index=0&id=2f6b3d27&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6b3d27"]])

export default __exports__